module.exports = __webpack_public_path__ + "img/application.5b82d9b5.jpg";